import React from 'react';
import { Container } from 'rsuite';
import { PageProps } from '../../../../../@types';
import { ModalOptimizationSummary } from '../../../../../components/ModalOptimizationSummary';
import { useCheckUserAllowAccess } from '../../hooks/useCheckUserAllowAccess';
import styles from './OtimizacaoPrecos.module.scss';
import { GridFilters } from './components/Filters';
import { GridHeader } from './components/Header';
import { GridMessage } from './components/Message/GridMessage';
import { ModalConfirmAction } from './components/ModalConfirmAction';
import { GridTable } from './components/Table';

export type CriarOtimizacaoProps = React.HTMLAttributes<HTMLElement> & PageProps;

const MemoHeader = React.memo(GridHeader);
const MemoMessage = React.memo(GridMessage);
const MemoFilters = React.memo(GridFilters);
const MemoTable = React.memo(GridTable);
const MemoModalConfirmAction = React.memo(ModalConfirmAction);
const MemoModalOptimizationSummary = React.memo(ModalOptimizationSummary);

export const OtimizacaoPrecosLista = ({ usuario }: CriarOtimizacaoProps) => {
  useCheckUserAllowAccess({ usuario });

  return (
    <Container className="main-container ">
      <div className={styles.container}>
        <MemoHeader />
        <MemoMessage />
        <MemoFilters />
        <MemoTable />
        <MemoModalConfirmAction />
        <MemoModalOptimizationSummary />
      </div>
    </Container>
  );
};
